import { GET_CREDIT_CARD_BANNER_DATA } from '../actionTypes/CreditCardBannerDataActionTypes';

const getCreditCardBannerData = (payload) => ({
    type: GET_CREDIT_CARD_BANNER_DATA,
    payload,
});

export default getCreditCardBannerData;
